// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Ej-z","zenCrossSiteLabel":"Fj-z","vrsnlCrossSiteLabel":"Gj-z"};